module.exports = __webpack_public_path__ + "img/openfirehydrant.dc59ddd5.svg";